<template>
  <div class="bankruptcy">
    <el-form :model="form" ref="form" label-width="110px" class="demo-form">
      <el-row>
        <el-col :span="24">
          <el-form-item label="破产企业名称">
            <el-input v-model="form.name" style="width:98%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="代理律师(主)">
            <el-select
              
              v-model="form.leadLawyer"
              placeholder="请选择"
              class="select"
              clearable
              filterable
            >
              <el-option
                v-for="item in Lawyer"
                :key="item.id"
                :label="item.nikename"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6"> </el-col>

        <el-col :span="6">
          <el-form-item label="破产项目来源">
            <el-select
              v-model="form.soure"
              placeholder="请选择"
              class="select"
              clearable
              filterable
            >
              <el-option
                v-for="item in SoureOptions"
                :key="item.id"
                :label="item.nikename"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item class="cder" label="开始时间">
            <el-date-picker
              class="select"
              v-model="form.starttime"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="起始"
              clearable
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item class="cder" label="结束时间">
            <el-date-picker
              clearable
              class="select"
              v-model="form.endtime"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="终止"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item>
        <div style="text-align: center">
          <el-button type="primary" @click="inputCase()">搜索</el-button>

          <el-button type="danger" @click="clickReset()">重置</el-button>
        </div>
      </el-form-item>
    </el-form>

    <el-table
      :data="tableData"
      :header-cell-style="{ textAlign: 'center' }"
      :cell-style="{ textAlign: 'center' }"
      style="width: 100%"
    >
      <el-table-column prop="name" label="破产企业名称"></el-table-column>
      <el-table-column prop="code" label="编号" width="180"></el-table-column>
      <el-table-column prop="soure" label="破产项目来源" width="180">
      </el-table-column>
      <el-table-column prop="cb_lvshi" label="代理律师" width="180">
      </el-table-column>
      <el-table-column prop="sh_lvshi" label="审核人/风控委" width="180">
        <template slot-scope="scope">
          {{ arrobjectToString(scope.row.sh_lvshi) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="collectiondate"
        label="收案时间"
        width="150"
        :formatter="formatTime"
      >
        <template slot-scope="scope">
          {{ formatTime(scope.row.collectiondate) }}
        </template></el-table-column
      >
      <el-table-column
        prop="createdate"
        label="提交时间"
        width="150"
        :formatter="formatTime"
        ><template slot-scope="scope">
          {{ formatTime(scope.row.createdate) }}
        </template></el-table-column
      >
      <el-table-column label="状态" width="100" prop="status">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0" type="text" class="casestatus"
            >正常(已通过)</span
          >
          <span v-if="scope.row.status == 1" type="text" class="casesresult"
            >待审核</span
          >
          <span v-if="scope.row.status == 2" type="text" class="casesrefuse"
            >未通过</span
          >
          <span v-if="scope.row.status == -1" type="text" class="casesrefuse"
            >已删除</span
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="300">
        <template slot-scope="scope">
          <el-button
            type="primary"
            plain
            size="small"
            @click="selectCase(scope.row.id)"
            >查看</el-button
          >
          <el-button
            type="success"
            plain
            size="small"
            @click="passCase(scope.row.id)"
            v-if="
              scope.row.status == 1 &&
              $store.state.rolesname.includes('bankruptcy_pass')
            "
            >通过</el-button
          >
          <el-button
            type="warning"
            plain
            size="small"
            @click="rejectCase(scope.row.id)"
            v-if="
              scope.row.status == 1 &&
              $store.state.rolesname.includes('bankruptcy_reject')
            "
            >驳回</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[1, 5, 10, 15, 20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <el-dialog
      title="详情"
      :visible.sync="detailsDialog"
      width="50%"
      style="text-align: center"
    >
      <el-form
        :model="dialogForm"
        :rules="rules"
        ref="dialogForm"
        label-width="150px"
        class="demo-form"
      >
        <el-form-item label="破产企业名称" prop="name">
          <el-input disabled v-model="dialogForm.name"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="代理律师(主)" prop="leadLawyer">
              <el-select
                style="width: 100%"
                v-model="dialogForm.leadLawyer"
                placeholder="请选择"
                class="select"
                clearable
                filterable
                @change="LeadLawyerChange(dialogForm.leadLawyer)"
                disabled
              >
                <el-option
                  v-for="item in Lawyer"
                  :key="item.id"
                  :label="item.nikename"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="代理律师(副)" prop="coCounsel">
              <el-select
                style="width: 100%"
                v-model="dialogForm.coCounsel"
                placeholder="请选择"
                class="select"
                clearable
                multiple
                filterable
                disabled
              >
                <el-option
                  v-for="item in Lawyer"
                  :key="item.id"
                  :label="item.nikename"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="破产项目来源" prop="soure">
              <el-select
                style="width: 100%"
                v-model="dialogForm.soure"
                placeholder="请选择"
                class="select"
                clearable
                filterable
                disabled
              >
                <el-option
                  v-for="item in SoureOptions"
                  :key="item.nikename"
                  :label="item.label"
                  :value="item.nikename"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收案日期" prop="approvaldate">
              <div
                class="date_box"
                @mouseover="onMouseOver()"
                @mouseleave="onMouseleave()"
              >
                <el-date-picker
                  style="width: 100%"
                  v-model="dialogForm.approvaldate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="请选择"
                  clearable
                  disabled
                >
                </el-date-picker>
                <i class="el-icon-date" ref="iconDate"></i>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="部门审批人"
              prop="caseLeaders"
              key="caseLeaders"
            >
              <el-select
                style="width: 100%"
                v-model="dialogForm.caseLeaders"
                placeholder="请选择"
                class="select"
                filterable
                clearable
                disabled
              >
                <el-option
                  v-for="item in CaseLeaders"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="二次审批人" prop="level">
              <el-select
                style="width: 100%"
                v-model="dialogForm.level"
                placeholder="请选择"
                class="select"
                clearable
                filterable
                disabled
              >
                <el-option
                  v-for="item in Level"
                  :key="item.id"
                  :label="item.nikename"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="用章类型" prop="sealtype">
          <el-select
            style="width: 100%"
            v-model="dialogForm.sealtype"
            placeholder="请选择"
            class="select"
            clearable
            filterable
            disabled
          >
            <el-option
              v-for="item in Seal"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <div style="text-align: center">
            <el-button
              type="success"
              plain
              @click="passCase(dialogForm.id)"
              v-if="
                dialogForm.status == 1 &&
                $store.state.rolesname.includes('bankruptcy_pass')
              "
              >通过</el-button
            >
            <el-button
              type="warning"
              plain
              @click="rejectCase(dialogForm.id)"
              v-if="
                dialogForm.status == 1 &&
                $store.state.rolesname.includes('bankruptcy_reject')
              "
              >驳回</el-button
            >
            <el-button type="warning" @click="detailsDialog = false"
              >关闭</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  caseLawyerApi,
  oldSelect,
  examineCase,
  caseSuccess,
  reject
} from '../../api/case'
import { GetDepartmentLeaders } from '../../api/bankrupt'
import { user } from '../../api/seal'
export default {
  name: 'bankruptcyManagerCheck',
  data() {
    var ajstatusCheck = (rule, value, callback) => {
      if (value == null || value === undefined || value == '' || value == []) {
        callback(new Error('请输入或选择！'))
      }
      callback()
    }
    return {
      form: {
        name: null,
        leadLawyer: null,
        soure: null,
        starttime: null,
        endtime: null,
        status: null
      },
      dialogForm: {
        id: null,
        name: null,
        leadLawyer: null,
        coCounsel: null,
        soure: null,
        approvaldate: null,
        caseLeaders: null,
        level: null,
        sealtype: null,
        status: null
      },

      rules: {
        name: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur', 'change']
          }
        ],
        leadLawyer: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur', 'change']
          }
        ],
        soure: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur', 'change']
          }
        ],
        approvaldate: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur', 'change']
          }
        ],
        caseLeaders: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur', 'change']
          }
        ],
        level: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur', 'change']
          }
        ],
        sealtype: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ['blur', 'change']
          }
        ]
      },

      SoureOptions: [
        { label: '投标', nikename: '投标' },
        { label: '指定', nikename: '指定' }
      ],
      States: [
        { label: '正常(审核通过)', nikename: '正常(审核通过)' },
        { label: '审核中', nikename: '审核中' },
        { label: '审核未通过', nikename: '审核未通过' },
        { label: '删除', nikename: '删除' }
      ],
      // 代理律师
      Lawyer: [],
      // 部门审批人
      CaseLeaders: [],
      // 二次审批人
      Level: [],
      // 用章类型
      Seal: [
        { value: 'contract_seal', label: '合同章' },
        { value: 'corporate_seal', label: '法人章' },
        { value: 'official_seal', label: '公章' },
        { label: '公章+法人章', value: 'official_corporate_seal' },
        { label: '合同章+法人章', value: 'contract_corporate_seal' },
        { label: '法律意见书专用章', value: 'law_seal' },
        { label: '律师函专用章', value: 'legal_letter_seal' }
      ],

      // 分页
      currentPage: 1,
      pageSize: 10,
      total: 0,

      // 回显
      tableData: [],

      detailsDialog: false,
      dlb: false
    }
  },

  methods: {
    // 通过
    passCase(id) {
      //Success
      caseSuccess({
        Id: id,
        Reason: null
      })
        .then((res) => {
          if (res.data.status == 'success') {
            this.$message.success('审核成功')
            this.inputCase()
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
            return
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch(() => {
          this.$message.error('前台错误！')
        })
    },
    // 驳回
    rejectCase(id) {
      //Reject
      reject({
        Id: id,
        Reason: null
      })
        .then((res) => {
          if (res.data.status == 'success') {
            this.$message.success('审核成功')
            this.inputCase()
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
            return
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch(() => {
          this.$message.error('前台错误！')
        })
    },
    // 代理律师/申请人/代理律师
    GetLawyer() {
      caseLawyerApi({}).then((res) => {
        if (res.data.status == 'success') {
          this.Lawyer = res.data.data
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
          return
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 获取案件审核部门主管
    GetDepartmentLeaders(lvshi) {
      if (lvshi == '' || lvshi == null) {
        return
      }

      GetDepartmentLeaders({
        Id: lvshi
      }).then((res) => {
        if (res.data.status == '0') {
          this.CaseLeaders = res.data.data
          var index = this.CaseLeaders.findIndex((item) => {
            return item.value == this.form.caseLeaders
          })
          // console.log("index:"+index)
          if (index == -1) {
            //不存在，清空
            this.form.caseLeaders = ''
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
          return
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 案件二次审批人/用章二次审批人
    GetLevel(lvshi) {
      if (lvshi == '' || lvshi == null) {
        return
      }
      user({
        Id: this.form.leadLawyer,
        apporver: 'case_00000000-0011-0011-0012-000000000000'
      }).then((res) => {
        if (res.data.status == 'success') {
          this.Level = res.data.data
          var index = this.Level.findIndex((item) => {
            return item.id == this.form.level
          })
          if (index == -1) {
            //不存在，清空二次审批人
            this.form.level = ''
          }
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
          return
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 代理律师 改变
    LeadLawyerChange(lvshi) {
      this.GetDepartmentLeaders(lvshi)
      this.GetLevel(lvshi)
    },

    // 重置
    clickReset() {
      this.form.name = null
      this.form.leadLawyer = null
      this.form.soure = null
      this.form.starttime = null
      this.form.endtime = null
      this.form.status = null
    },

    // 承办律师
    arrToString(arr) {
      return arr.join(' , ')
    },
    // 审核人/风控委
    arrobjectToString(arrobject) {
      var s = ''
      arrobject.forEach((value, index) => {
        // s += value.nikename
        // if (index < arrobject.length - 1) {
        //   s = s + '，'
        // }

        s += value
        if (index < arrobject.length - 1) {
          s = s + '，'
        }
      })
      return s
    },

    // 分页查询
    handleSizeChange(val) {
      this.pageSize = val
      this.inputCase()
    },
    // 分页查询
    handleCurrentChange(val) {
      this.currentPage = val
      this.inputCase()
    },

    // 查询
    inputCase() {
      examineCase({
        name: this.form.name == '' ? null : this.form.name,
        leadLawyer: this.form.leadLawyer == '' ? null : this.form.leadLawyer,
        soure: this.form.soure == '' ? null : this.form.soure,
        starttime: this.form.starttime == '' ? null : this.form.starttime,
        endtime: this.form.endtime == '' ? null : this.form.endtime,
        status: this.form.status == '' ? null : this.form.status,
        page: this.currentPage,
        rows: this.pageSize
      })
        .then((res) => {
          if (res.data.status == 'success') {
            this.total = res.data.total
            this.tableData = res.data.data
          }
        })
        .catch((err) => {
          console.log('查询失败', err)
        })
    },

    // 明细查询
    selectCase(id) {
      oldSelect({ bkid: id })
        .then((res) => {
          if (res.data.data != null) {
            this.dialogForm.id = res.data.data[0].id
            this.dialogForm.approvaldate = this.formatTime(
              res.data.data[0].collectionDate
            )
            this.dialogForm.coCounsel = res.data.data[0].deputyLawyer
            this.dialogForm.leadLawyer = res.data.data[0].mainLawyer
            this.dialogForm.name = res.data.data[0].name
            this.dialogForm.soure = res.data.data[0].soure
            this.dialogForm.status = res.data.data[0].status
            this.dialogForm.caseLeaders = res.data.data[0].sh_lvshi[0].memberId
            this.dialogForm.level = res.data.data[0].sh_lvshi[1].memberId
            this.dialogForm.sealtype = res.data.data[0].sealType
            this.detailsDialog = true

            if (res.data.data[0].status != 2) {
              // 不可编辑
              this.dlb = true
            }
          }
        })
        .catch(() => {})
    },
    // --时间格式转换--
    formatTime(row) {
      const date = new Date(row)
      // return row[column.property].Format('yyyy-MM-dd HH:mm')
      var year = date.getFullYear()
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      var month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      var minutes =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      var seconds =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      // 拼接
      if (hours == '00' && minutes == '00' && seconds == '00') {
        return year + '-' + month + '-' + day
      } else {
        return (
          year + '-' + month + '-' + day
          // +
          // ' ' +
          // hours +
          // ':' +
          // minutes +
          // ':' +
          // seconds
        )
      }
    },

    onMouseOver() {
      if (this.dialogForm.approvaldate != undefined) {
        this.$refs.iconDate.style.display = 'none'
      }
    },
    onMouseleave() {
      this.$refs.iconDate.style.display = 'block'
    }
  },

  created() {
    this.GetLawyer()
    this.inputCase()
  },

  watch: {
    'dialogForm.leadLawyer': {
      handler(newValue, oldValue) {
        this.LeadLawyerChange(this.dialogForm.leadLawyer)
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
.bankruptcy {
  .select {
  width: 10vw;
  margin-right: 10px;
}
  .date_box {
    .el-icon-date {
      position: absolute;
      top: 50%;
      right: 10px;
      z-index: 9;
      color: #c0c4cc;
      font-size: 14px;
      transform: translateY(-50%);
    }

    /deep/ .el-range__close-icon {
      position: absolute;
      right: 34px;
      top: 54%;
      transform: translateY(-50%);
    }
  }

  .casestatus {
    color: #2bc887;
  }

  .casesresult {
    color: #fe964a;
  }

  .casesrefuse {
    color: #df0d0d;
  }

  .pagination {
    // margin-top: 18px;
    margin: 20px 0px 20px 0px;
    width: 100%;
    overflow: hidden;
    text-align: right;
  }

  .right {
    width: 80%;
    margin: auto;
    margin-top: 3.125rem;
  }

  /* ::v-deep穿透 改变element ui组件样式 */
  ::v-deep .pagination .el-pagination__total {
    float: left;
  }

  ::v-deep .pagination .el-pagination__sizes {
    float: left;
  }
}
</style>